// extracted by mini-css-extract-plugin
export var readonly = "_hs-1";
export var star = "_hs-0";